import { render } from "./class-selector.vue?vue&type=template&id=9b6c97e4"
import script from "./class-selector.vue?vue&type=script&lang=js"
export * from "./class-selector.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__